import { usePublicShopSuspense } from "@babackapp/private-api-client/client/use-shop-suspense";

export function usePublicShop(shopId: string) {
  return usePublicShopSuspense(shopId);
}
